import { FETCH_COGNITO_USER } from "./index";

export const setCognitoUser = (payload) => {
  return {
    type: FETCH_COGNITO_USER,
    payload: payload,
  };
};
